import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { INVITATION_STATUSES } from '../../lib/invitations';
import { toFullName } from '../../lib/users';
import routes from '../../routes';
import { directLinkInfoPropType, invitationTypePropType } from '../prop-types';
import AnswerRequestForm from './Form';
import PhoneValidation from './PhoneValidation';

export default function DirectLinkAnswerRequest({
  countryCode,
  invitationInfo: { status, inviterData, inviteeData },
  invitationType,
  onSignIn,
  onSubmit,
  onSubmitWithAuth,
  phoneNumber,
}) {
  const { t } = useTranslation();

  const renderContactAdded = useCallback(
    props => (
      <PhoneValidation
        inviterName={toFullName(inviterData)}
        onSubmitWithAuth={onSubmitWithAuth}
        onSignIn={onSignIn}
        phoneNumber={phoneNumber}
        {...props}
      />
    ),
    [inviterData, onSignIn, onSubmitWithAuth, phoneNumber],
  );

  const renderRequestForm = useCallback(
    () => (
      <AnswerRequestForm
        invitationType={invitationType}
        inviterName={toFullName(inviterData)}
        initialValues={{ ...inviteeData, countryCode }}
        onSubmit={onSubmit}
        title={t(
          'answerRequest.directLinks.title',
          { inviterName: toFullName(inviterData), invitedName: inviteeData.firstName },
        )}
      />
    ),
    [countryCode, invitationType, inviteeData, inviterData, onSubmit, t],
  );

  if (status !== INVITATION_STATUSES.pending) {
    return <Redirect to={routes.download} />;
  }

  return (
    <Switch>
      <Route path={routes.answerRequest.contactAdded} render={renderContactAdded} />
      <Route render={renderRequestForm} />
    </Switch>
  );
}

DirectLinkAnswerRequest.propTypes = {
  countryCode: PropTypes.string.isRequired,
  invitationInfo: directLinkInfoPropType.isRequired,
  invitationType: invitationTypePropType.isRequired,
  onSignIn: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSubmitWithAuth: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string,
};

DirectLinkAnswerRequest.defaultProps = {
  phoneNumber: undefined,
};
